// extracted by mini-css-extract-plugin
export default {"body":"styles_body__BkwFx","emptyRow":"styles_emptyRow__ttxwO","emptyCell":"styles_emptyCell__uJN6f"};